import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type DeleteAllVolumetricMaterials = ClientInferResponseBody<
  typeof contract.materials.deleteAllVolumetricMaterials
>;

export const deleteAllVolumetricMaterials = async (): Promise<DeleteAllVolumetricMaterials> => {
  const response = await api.materials.deleteAllVolumetricMaterials.mutation({
    body: {},
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to delete all volumetric materials", response.status, response.body);
};
